import type { TNavbarMenuBurgerContentElement } from '@shared/dream-components';
import { NavbarMenuBurgerContent as NavbarMenuBurgerContentElement } from '@shared/dream-components';
import { type ReactNode, Suspense } from 'react';

interface Props {
  node: TNavbarMenuBurgerContentElement;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const NavbarMenuBurgerContent = ({ node, children, screen }: Props) => {
  return (
    <Suspense fallback={null}>
      <NavbarMenuBurgerContentElement element={node} screen={screen} controlbyselected="false">
        {children}
      </NavbarMenuBurgerContentElement>
    </Suspense>
  );
};

export default NavbarMenuBurgerContent;
